export default {
  data() {
    return {
      availableWishes: [
        // Expected format:
        // {
        //   key: '1-green',
        //   label: '',
        // },
      ],
    };
  },
  methods: {
    getWishes() {
      const w = JSON.parse(JSON.stringify(this.availableWishes));

      if (w.length > 0) {
        w.push({
          key: 'none',
          label: 'Inga särskilda önskemål',
        });
      }

      return w;
    },
    getWishesAsList(wishes) {
      if (!wishes) {
        return [];
      }

      // Clone array this.availableWishes so we can modify it without affecting the original
      const availableWishes = JSON.parse(JSON.stringify(this.availableWishes));
      availableWishes.push({
        key: 'none',
        label: 'Inga särskilda önskemål',
      });

      const wishKeys = Object.keys(wishes).filter(key => wishes[key] === true);
      const wishLabels = availableWishes
        .filter(wish => wishKeys.indexOf(wish.key) !== -1)
        .map(wish => wish.label);

      if (wishes.freeText && wishes.freeText.trim() !== '') {
        wishLabels.push(wishes.freeText);
      }

      return wishLabels;
    },
    getWishesAsListForSave(wishes) {
      if (!wishes) {
        return '';
      }

      // Clone array this.availableWishes so we can modify it without affecting the original
      const availableWishes = JSON.parse(JSON.stringify(this.availableWishes));
      availableWishes.push({
        key: 'none',
        label: 'Inga särskilda önskemål',
      });

      const wishKeys = Object.keys(wishes).filter(key => wishes[key] === true);
      const wishLabels = availableWishes
        .filter(wish => wishKeys.indexOf(wish.key) !== -1)
        .map(wish => wish.label);

      if (wishes.freeText && wishes.freeText.trim() !== '') {
        wishLabels.push(wishes.freeText);
      }

      // Go through all wishLabels and remove ending period
      // and trim whitespace, then join with '. ' so it is saved as one string
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < wishLabels.length; i++) {
        wishLabels[i] = wishLabels[i].replace(/\.$/, '').trim();
      }

      return wishLabels.join('. ');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/schoolWishes.js